import { NgModule } from '@angular/core';
import { CompatABTestComponent } from './compat-abtest.component';

@NgModule({
  declarations: [CompatABTestComponent],
  entryComponents: [CompatABTestComponent],
})
export class CompatABTestModule {}
